import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
    Form,
    Input,
    Modal,
    Typography,
    Button,
    DatePicker,
    notification,
} from "antd";
import moment from "moment";
import axios from "axios";
import dayjs from "dayjs";
import ShelfLifeAnalysisApi from "../../Apis/ShelfLifeAnalysisApi";
const { Title } = Typography;

function ShelfLifeAnalysis({ visible, onClose, afterCookId, Production }) {
    const [formAdd] = Form.useForm();
    console.log(Production);
    const navigate = useNavigate();
    const UserDetails = JSON.parse(localStorage.getItem("UserDetails"));
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
    
    formAdd.setFieldsValue({
        productId: afterCookId?.productionDTO?.id,
        SellDate: dayjs(afterCookId?.productionDTO?.sellByDate),
    });

    const [ImportFile, setImportFile] = useState(null);
    const [isDisable, setIsDisable] = useState(true);
    const [isDisablebtn, setIsDisablebtn] = useState(false);
    
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        console.log("Selected File:", file);

        if (file) {
            // Validate file size (optional - example: max 5MB)
            if (file.size > 5 * 1024 * 1024) {
                notification.open({
                    message: <span style={{ fontWeight: "bold" }}>Error</span>,
                    description: "File size should be less than 5MB",
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#fff2f0",
                        color: "red",
                    },
                });
                setIsDisable(true);
                setImportFile(null);
                event.target.value = null;
                return;
            }
            
            setIsDisable(false);
            setImportFile(file);
        } else {
            setIsDisable(true);
            setImportFile(null);
        }
    };
    
    const handleSubmit = async (data) => {
        // Check if file is selected
        if (!ImportFile) {
            notification.open({
                message: <span style={{ fontWeight: "bold" }}>Error</span>,
                description: "Please select a file to upload",
                closeIcon: false,
                duration: 3,
                style: {
                    backgroundColor: "#fff2f0",
                    color: "red",
                },
            });
            return;
        }
        
        setIsDisablebtn(true);
        
        const SellDateAnalysis = dayjs(data.SellDateAnalysis).format("DD/MM/YYYY");
        const renewalDate = dayjs(data.renewalDate).format("DD/MM/YYYY");
        
        let formData = JSON.stringify({
            shelfLifeAnalysisDate: convertToUnixTimestamp(SellDateAnalysis),
            renewalDate: convertToUnixTimestamp(renewalDate),
            tenantDTO: {
                id: decodedToken?.tenantId,
            },
            institutionDTO: {
                id: Production?.institutionDTO?.id,
            },
            productDTO: {
                id: Production?.id,
            },
        });
        
        try {
            // Step 1: Create Shelf Life Analysis
            const response = await ShelfLifeAnalysisApi.CreateShelfLifeAnalysis(formData);
            console.log("Shelf Life Analysis Created:", response?.payload?.id);
            
            // Step 2: Upload the document using the new API function
            await ShelfLifeAnalysisApi.UploadShelfLifeDocument(response?.payload?.id, ImportFile);
            
            // Success Notification
            notification.open({
                message: <span style={{ fontWeight: "bold" }}>Success</span>,
                description: "Shelf Life Analysis Created Successfully with Document",
                closeIcon: false,
                duration: 3,
                style: {
                    backgroundColor: "#b3ffb3",
                    color: "green",
                },
            });
            
            // Reset form and close modal
            formAdd.resetFields();
            setImportFile(null);
            setIsDisable(true);
            
            // Reload after short delay
            setTimeout(() => {
                window.location.reload();
            }, 1500);
            
        } catch (err) {
            console.log("Error:", err);
            setIsDisablebtn(false);
            
            // Error Notification
            const errorMessage = err?.apiError?.message || err?.message || "An error occurred while creating Shelf Life Analysis";
            notification.open({
                message: <span style={{ fontWeight: "bold" }}>Error</span>,
                description: errorMessage,
                closeIcon: false,
                duration: 3,
                style: {
                    backgroundColor: "#fff2f0",
                    color: "red",
                },
            });
        }
    };

    function convertToUnixTimestamp(dateString) {
        const parts = dateString.split("/");
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);
        const unixTimestamp = Date.UTC(year, month, day);
        return unixTimestamp;
    }

    const currentDate = moment().format("DD/MM/YYYY");

    const handleCancel = () => {
        formAdd.resetFields();
        setImportFile(null);
        setIsDisable(true);
        setIsDisablebtn(false);
        onClose();
    };

    return (
        <>
            <Modal
                footer={[]}
                width={600}
                visible={visible}
                maskClosable={false}
                onCancel={handleCancel}
                onOk={onClose}
            >
                <Title level={4} className="text-center Primary-Font mb-4 pb-3">
                    Shelf Life Analysis
                </Title>
                <Form
                    form={formAdd}
                    name="nest-messages"
                    layout="horizontal"
                    labelCol={{
                        span: 9,
                    }}
                    wrapperCol={{
                        span: 15,
                    }}
                    className="FormClass IndividualProduct-Model"
                    onFinish={handleSubmit}
                >
                    <>
                        <Form.Item
                            name="SellDateAnalysis"
                            label="Shelf Life Analysis Date"
                            className="text-lable "
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Shelf Life Analysis Date",
                                },
                            ]}
                        >
                            <DatePicker
                                format={"DD/MM/YYYY"}
                                className="form-control control-input"
                                disabled={isDisablebtn}
                            />
                        </Form.Item>
                        
                        <Form.Item
                            name="renewalDate"
                            label="Renewal Date"
                            className="text-lable "
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Renewal Date",
                                },
                            ]}
                        >
                            <DatePicker
                                format={"DD/MM/YYYY"}
                                className="form-control control-input"
                                disabled={isDisablebtn}
                            />
                        </Form.Item>

                        <Form.Item
                            name="uploadFile"
                            label="Upload File"
                            className="text-lable "
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Upload",
                                },
                            ]}
                        >
                            <Input
                                type="file"
                                accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                id="fileInput"
                                onChange={handleFileChange}
                                placeholder="Upload File"
                                className="control-input"
                                disabled={isDisablebtn}
                            />
                        </Form.Item>

                        {ImportFile && (
                            <div style={{ 
                                textAlign: "center", 
                                marginBottom: "16px",
                                padding: "8px",
                                backgroundColor: "#f0f9ff",
                                borderRadius: "4px",
                                fontSize: "12px",
                                color: "#0958d9"
                            }}>
                                Selected File: {ImportFile.name} ({(ImportFile.size / 1024).toFixed(2)} KB)
                            </div>
                        )}

                        <div
                            className="d-flex justify-content-between pt-4"
                            style={{
                                gap: "10px",
                            }}
                        >
                            <Button
                                onClick={handleCancel}
                                disabled={isDisablebtn}
                                style={{
                                    flex: 1,
                                    height: 40,
                                    borderRadius: 6,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#000",
                                    textDecoration: "none",
                                    fontWeight: 500,
                                }}
                            >
                                Cancel
                            </Button>

                            <Button
                                disabled={isDisablebtn || isDisable}
                                type="primary"
                                htmlType="submit"
                                loading={isDisablebtn}
                                style={{
                                    flex: 1,
                                    height: 40,
                                    borderRadius: 6,
                                    fontWeight: 500,
                                }}
                            >
                                {isDisablebtn ? "Creating..." : "Create"}
                            </Button>
                        </div>
                    </>
                </Form>
            </Modal>
        </>
    );
}

export default ShelfLifeAnalysis;